/**
 * @author xyguo
 * @date 2020-10-31
 * @desc 作业查看
 */
import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { WizAuthority, WizBraftEditorPlus } from "../../../common";
import { Row, Col } from 'antd';
import { element } from "prop-types";

import { AudienceGroupItem, PhotoPreview } from '@/components';

let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils } = framework_tool
let { WizCard, WizSelect, WizForm, Wizmessage, WizRow, WizCol, WizInput, WizSpin, WizModal, WizBraftEditor } = component_tool
let { Session } = utils_tool

const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class HomeworkInfo extends WizContainer {
  componentName = 'homeworkInfo'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    let pathname = '/homework/homeworkList'
    if (history.location && history.location.pathname && history.location.pathname.startsWith('/perm/homeworkListPerm')) {
      pathname = '/perm/homeworkListPerm'
    }
    if (history.location && history.location.pathname === pathname + '/homeworkInfo') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('homeworkInfo', detailInfo)
      } else {
        detailInfo = Session.get('homeworkInfo') || {}
      }
    }
    this.state = {
      time: undefined,
      previewImgVisible: false,
      previewImgKey: new Date().getTime(),
      previewImage: '',
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
    if (this.detailInfo.id) {
      this.doAction({
        path: 'homework/getInfo',
        payload: {
          key: "gethomeworkInfo",
          apiParams: {
            id: this.detailInfo.id
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    homeworkInfo: this._gethomeworkInfoOver.bind(this)
  }

  _gethomeworkInfoOver(nextProps, nextState) {
    if (nextProps.homeworkInfo.code == 1) {
      this.detailInfo = nextProps.homeworkInfo.data;
      nextState.time = new Date().getTime();
    }
    return true;
  }

  authorityInfo = () => {
    let initialValue = {
      groupId: null,
      isAll: null,
      orgIds: [],
      positionIds: [],
      positionCategoryIds: [],
      personIds: [],
      message: []
    }
    if (this.detailInfo && this.detailInfo.authInfo) {
      initialValue = this.detailInfo.authInfo
    }
    return (
      <AudienceGroupItem {...initialValue} />
    )
  }

  /** 打开图片查看*/
  handlePreview = async element => {
    let file = element.urlOld
    let fileId = element.fileId
    let fileName = element.element
    let imgProps = {
      ...file,
      uid: fileId + '_',
      name: fileName,
      status: 'done',
    }
    if (!imgProps.url && !imgProps.preview) {
      imgProps.preview = await getBase64(imgProps.originFileObj);
    }
    this.setState({
      previewImage: imgProps.url || imgProps.preview,
      previewImgVisible: true,
      previewImgKey: new Date().getTime(),
    });
  };

  /** 关闭查看Model*/
  handleCancel = () => this.setState({
    previewImgVisible: false
  });

  getImgInfo = (type) => {
    let record = this.detailInfo
    let datas = [];
    if (type === 'img') {
      datas = record.imgMimes
    } else if (type === 'video') {
      datas = record.videoMimes
    } else if (type === 'audio') {
      datas = record.audioMimes
    } else if (type === 'file') {
      datas = record.fileMimes
    }
    let urls = [];
    datas.forEach(element => {
      let urlOld = ossFileUtils.getOssFile(
        element.img,
        element.fileName,
        element.fileMimeType,
        element.fileSize,
        element.fileUri,
      )
      let url = urlOld.url
      url = element.fileUri ? url : constants.files.sys_img_loadingFailed;
      let fileObj = {};
      fileObj.url = url;
      fileObj.fileName = element.fileName
      fileObj.urlOld = urlOld
      fileObj.fileId = element.fileId
      urls.push(fileObj);
    });
    let show = []
    urls.forEach(e => {
      if (type === 'img') {
        show.push(<Col span={4.5} >
          <PhotoPreview img={e.url} height={80} width={130} style={{ margin: 5, objectFit: 'cover' }}></PhotoPreview>
          {/* <img height={80} width={130} style={{margin:5, objectFit: 'cover' }} src={e.url} onClick={p => this.handlePreview(e)}/> */}
        </Col>)
      } else {
        show.push(<Col span={24} ><div height={80} width={130} style={{ margin: 5 }} >
          <a href={e.url} target="_blank" style={{ color: "blue" }}>{e.fileName}</a>
        </div></Col>)
      }
    })

    return (
      <Row type='flex' justify='start' gutter={{ xs: 4.5, sm: 16, md: 24 }}>
        {show}
      </Row>
    )

  }

  _createIntro = (requirement) => {
    if (requirement && document.getElementById("homework_intro") != null) {
      document.getElementById(
        "homework_intro"
      ).innerHTML = WizBraftEditor.createEditorState(requirement).toHTML();
    }
  }


  _render() {
    const items = this.detailInfo
    return (
      <React.Fragment>
        <WizSpin tip={'加载中'} spinning={this.props.homeworkLoading}>
          <WizCard>
            <Descriptions column={1} bordered={true}>
              <Descriptions.Item label='标题'>{items.name}</Descriptions.Item>
              <Descriptions.Item label='要求'> <div id='homework_intro'>{this._createIntro(items.requirement)} </div>
                {/* <WizBraftEditorPlus value={items.requirement} disabled={true} /> */}
              </Descriptions.Item>
              <Descriptions.Item label='分类'>{items.categoryName}</Descriptions.Item>
              <Descriptions.Item label='形式'>{items.typesName}</Descriptions.Item>
              <Descriptions.Item label='图片附件'>{this.getImgInfo('img')}</Descriptions.Item>
              <Descriptions.Item label='视频附件'>{this.getImgInfo('video')}</Descriptions.Item>
              <Descriptions.Item label='音频附件'>{this.getImgInfo('audio')}</Descriptions.Item>
              <Descriptions.Item label='文件附件'>{this.getImgInfo('file')}</Descriptions.Item>
              <Descriptions.Item label='是否允许重复提交'>{items.resubmitStr}</Descriptions.Item>
              <Descriptions.Item label='开始时间'>{items.startDate}</Descriptions.Item>
              <Descriptions.Item label='结束时间'>{items.endDate}</Descriptions.Item>
              <Descriptions.Item label='是否公开展示'>{items.openStr}</Descriptions.Item>
              <Descriptions.Item label='是否需要批阅'>{items.reviewTypeStr}</Descriptions.Item>
              <Descriptions.Item label='评分人'>{items.reviewersName}</Descriptions.Item>
              <Descriptions.Item label='满分'>{items.totalScore}</Descriptions.Item>
              <Descriptions.Item label='及格分'>{items.passScore}</Descriptions.Item>
              <Descriptions.Item label='受众'>{this.authorityInfo()}</Descriptions.Item>
              <Descriptions.Item label='状态'>{items.stateStr}</Descriptions.Item>
            </Descriptions>
            <WizModal key={'img_preview_' + this.state.previewImgKey} visible={this.state.previewImgVisible} footer={null}
              onCancel={this.handleCancel}>
              <img alt="example" style={{ width: '100%' }} src={this.state.previewImage} />
            </WizModal>
          </WizCard>
        </WizSpin>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { homework } = state;
  const homeworkInfo = modelUtils.getModelEntity(homework, "gethomeworkInfo");
  const load = modelUtils.getLoadingState(state, ['homework']);
  return {
    homeworkInfo,
    ...load
  }
};

export default connect(mapStateToProps)(HomeworkInfo)

